// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"055335a6","977":"7755195e"}[chunkId] + ".chunk.js";
};